import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface UserInfoResponse {
  data: null
  meta: {
    message: string
    errors: string[]
  }
}

export interface UserInfoPayload {
  first_name: string
  last_name: string
  first_name_en?: string
  last_name_en?: string
  birth_date?: string | null
  gender?: string
}

export function updateUserInfoAction(uuid: string, payload: UserInfoPayload): Promise<ApiResponse<UserInfoResponse>> {
  return api.patch<ApiResponse<UserInfoResponse>>(`/users/${uuid}/user-info`, { ...payload })
}
